(function () {
  var LENIS_VERSION = '1.3.23';
  var PREVENT_SELECTOR = [
    '[data-lenis-prevent]',
    '[data-global-dropdown]',
    '[role="dialog"]',
    '.modal',
    '.drawer',
    '.gm-modal__viewport',
    '.gm-modal__content',
    '.gm-modal__dialog',
    '.gdd__panel',
    '.site-mobile-nav',
    '.menu-mobile',
    '.map-application-dialog',
    '.rmc-pl__panel-body',
    '.rmc-pl__dialog-body',
    '.rmel__panel-body',
    '.rmel__panel-scroll',
    '.etm-modal__content',
    '.pte-modal',
    '.pte-map-frame-wrap',
    '.gm-form-flip-face--back',
    '.gm-form-flip-face--front',
    '.gmap_canvas',
    '.mapouter',
    'iframe'
  ].join(', ');

  var state = {
    lenis: null,
    rafId: 0,
    started: false,
    resizeTimer: 0,
    reducedMotionQuery: null,
    destroyFns: []
  };

  function isEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function getTabletBreakpoint() {
    var config = window.__themeGlobalExitFadeConfig || {};
    var parsed = parseInt(config.tabletBp, 10);
    return Number.isFinite(parsed) ? parsed : 991;
  }

  function getConfig() {
    return window.__themeLenisConfig || {};
  }

  function getNumberConfig(key, fallback) {
    var value = getConfig()[key];
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getBoolConfig(key, fallback) {
    var value = getConfig()[key];
    if (value === undefined || value === null) return fallback;
    return !!value;
  }

  function prefersReducedMotion() {
    if (!window.matchMedia) return false;
    if (!state.reducedMotionQuery) {
      state.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    }
    return !!state.reducedMotionQuery.matches;
  }

  function isDesktopViewport() {
    return (window.innerWidth || document.documentElement.clientWidth || 0) > getTabletBreakpoint();
  }

  function hasLegacySmoothScrollMode() {
    return !!document.getElementById('js-scroll');
  }

  function canRun() {
    return !!(
      window.Lenis &&
      getBoolConfig('enabledDesktop', false) &&
      !isEditor() &&
      !prefersReducedMotion() &&
      !hasLegacySmoothScrollMode() &&
      isDesktopViewport()
    );
  }

  function on(target, type, handler, options) {
    if (!target || typeof target.addEventListener !== 'function') return;
    target.addEventListener(type, handler, options);
    state.destroyFns.push(function () {
      try { target.removeEventListener(type, handler, options); } catch (_) {}
    });
  }

  function cancelRaf() {
    if (!state.rafId) return;
    cancelAnimationFrame(state.rafId);
    state.rafId = 0;
  }

  function raf(time) {
    if (!state.lenis) return;
    state.lenis.raf(time);
    state.rafId = requestAnimationFrame(raf);
  }

  function scheduleResize() {
    if (!state.lenis) return;
    if (state.resizeTimer) clearTimeout(state.resizeTimer);
    state.resizeTimer = window.setTimeout(function () {
      state.resizeTimer = 0;
      if (!state.lenis) return;
      try {
        state.lenis.resize();
      } catch (_) {}
    }, Math.max(0, getNumberConfig('resizeDebounceMs', 60)));
  }

  function evaluate() {
    if (canRun()) {
      start();
    } else {
      destroy();
    }
  }

  function start() {
    if (state.started || !canRun()) return;

    var lenis = new window.Lenis({
      autoRaf: false,
      smoothWheel: true,
      syncTouch: false,
      allowNestedScroll: getBoolConfig('allowNestedScroll', true),
      lerp: Math.max(0.01, getNumberConfig('lerp', 0.1)),
      wheelMultiplier: Math.max(0.1, getNumberConfig('wheelMultiplier', 1)),
      touchMultiplier: 1,
      autoResize: true,
      naiveDimensions: true,
      stopInertiaOnNavigate: true,
      prevent: function (node) {
        return !!(node && node.closest && node.closest(PREVENT_SELECTOR));
      }
    });

    state.lenis = lenis;
    state.started = true;
    document.documentElement.setAttribute('data-theme-lenis', 'true');
    document.documentElement.setAttribute('data-theme-lenis-version', LENIS_VERSION);
    cancelRaf();
    state.rafId = requestAnimationFrame(raf);

    if (!window.__themeLenis) {
      window.__themeLenis = {};
    }
    window.__themeLenis.instance = lenis;
    window.__themeLenis.version = LENIS_VERSION;
    window.__themeLenis.resize = scheduleResize;
    window.__themeLenis.start = start;
    window.__themeLenis.stop = function () {
      if (!state.lenis) return;
      try { state.lenis.stop(); } catch (_) {}
    };
    window.__themeLenis.destroy = destroy;
  }

  function destroy() {
    if (!state.started && !state.lenis) return;
    cancelRaf();
    if (state.resizeTimer) {
      clearTimeout(state.resizeTimer);
      state.resizeTimer = 0;
    }
    if (state.lenis) {
      try { state.lenis.destroy(); } catch (_) {}
    }
    state.lenis = null;
    state.started = false;
    document.documentElement.removeAttribute('data-theme-lenis');
    document.documentElement.removeAttribute('data-theme-lenis-version');
    if (window.__themeLenis) {
      window.__themeLenis.instance = null;
    }
  }

  function init() {
    if (window.__themeLenisBooted) return;
    window.__themeLenisBooted = true;

    evaluate();

    on(window, 'resize', evaluate);
    on(window, 'load', scheduleResize, { once: true });
    on(window, 'pageshow', function () {
      evaluate();
      scheduleResize();
    });
    on(window, 'theme:layout-change', scheduleResize);
    on(document, 'shopify:section:load', scheduleResize);
    on(document, 'shopify:section:unload', scheduleResize);
    on(document, 'shopify:section:reorder', scheduleResize);
    on(document, 'shopify:block:select', scheduleResize);
    on(document, 'shopify:block:deselect', scheduleResize);

    if (!state.reducedMotionQuery && window.matchMedia) {
      state.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    }
    if (state.reducedMotionQuery) {
      var mqHandler = function () {
        evaluate();
      };
      if (typeof state.reducedMotionQuery.addEventListener === 'function') {
        state.reducedMotionQuery.addEventListener('change', mqHandler);
        state.destroyFns.push(function () {
          try { state.reducedMotionQuery.removeEventListener('change', mqHandler); } catch (_) {}
        });
      } else if (typeof state.reducedMotionQuery.addListener === 'function') {
        state.reducedMotionQuery.addListener(mqHandler);
        state.destroyFns.push(function () {
          try { state.reducedMotionQuery.removeListener(mqHandler); } catch (_) {}
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
